<template>
	<div>
		<case-form :schema="schema" class="mt6" />

		<div class="xs-12 fs4 fw7 mt6 mb2">
			Please provide the following details:
		</div>

		<div class="xs-12 fs4 fw7 mt6 mb2">Father</div>
		<case-form :schema="schemaFather" />

		<div class="xs-12 fs4 fw7 mt6 mb2">Mother</div>
		<case-form :schema="schemaMother" />

		<div class="xs-12 fs4 fw7 mt6 mb2">Brothers and Sisters</div>
		<case-form :schema="schemaSiblings" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	data() {
		return {
			maxNumberOfList: 3
		}
	},

	computed: {
		schema() {
			return [
				{
					label:
						"Have any of your immediate family (parents, brothers or sisters) died of or been diagnosed as having coronary artery disease, cancer, stroke or kidney disease prior to age 60?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0hasFamilyBeenDiagnosedBefore60`,
					props: {
						suggest: {
							typeIncludes: `hasFamilyBeenDiagnosedBefore60`
						},
						createOptions: {
							type: `hasFamilyBeenDiagnosedBefore60`,
							dataType: "boolean"
						}
					}
				}
			]
		},

		schemaFather() {
			return [
				{
					label: `(If Living) Age`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0livingFatherAge`,
					props: {
						suggest: {
							typeIncludes: `livingFatherAge`
						},
						createOptions: {
							type: `livingFatherAge`,
							dataType: "string"
						}
					}
				},
				{
					label: `(If Living) Medical Condition(s)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0livingFatherMedicalConditions`,
					props: {
						suggest: {
							typeIncludes: `livingFatherMedicalConditions`
						},
						createOptions: {
							type: `livingFatherMedicalConditions`,
							dataType: "string"
						}
					}
				},
				{
					label: `(If Deceased) Age`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0deceasedFatherAge`,
					props: {
						suggest: {
							typeIncludes: `deceasedFatherAge`
						},
						createOptions: {
							type: `deceasedFatherAge`,
							dataType: "string"
						}
					}
				},
				{
					label: `(If Deceased) Case of death`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0deceasedFatherMedicalCauseOfDeath`,
					props: {
						suggest: {
							typeIncludes: `deceasedFatherMedicalCauseOfDeath`
						},
						createOptions: {
							type: `deceasedFatherMedicalCauseOfDeath`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaMother() {
			return [
				{
					label: `(If Living) Age`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0livingMotherAge`,
					props: {
						suggest: {
							typeIncludes: `livingMotherAge`
						},
						createOptions: {
							type: `livingMotherAge`,
							dataType: "string"
						}
					}
				},
				{
					label: `(If Living) Medical Condition(s)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0livingMotherMedicalConditions`,
					props: {
						suggest: {
							typeIncludes: `livingMotherMedicalConditions`
						},
						createOptions: {
							type: `livingMotherMedicalConditions`,
							dataType: "string"
						}
					}
				},
				{
					label: `(If Deceased) Age`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0deceasedMotherAge`,
					props: {
						suggest: {
							typeIncludes: `deceasedMotherAge`
						},
						createOptions: {
							type: `deceasedMotherAge`,
							dataType: "string"
						}
					}
				},
				{
					label: `(If Deceased) Cause of death`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0deceasedMotherCauseOfDeath`,
					props: {
						suggest: {
							typeIncludes: `deceasedMotherCauseOfDeath`
						},
						createOptions: {
							type: `deceasedMotherCauseOfDeath`,
							dataType: "string"
						}
					}
				}
			]
		},

		schemaSiblings() {
			return [
				{
					label: `(If Living) Age`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0livingSiblingAge`,
					props: {
						suggest: {
							typeIncludes: `livingSiblingAge`
						},
						createOptions: {
							type: `livingSiblingAge`,
							dataType: "string"
						}
					}
				},
				{
					label: `(If Living) Medical Condition(s)`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0livingSiblingMedicalConditions`,
					props: {
						suggest: {
							typeIncludes: `livingSiblingMedicalConditions`
						},
						createOptions: {
							type: `livingSiblingMedicalConditions`,
							dataType: "string"
						}
					}
				},
				{
					label: `(If Deceased) Age`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0deceasedSiblingAge`,
					props: {
						suggest: {
							typeIncludes: `deceasedSiblingAge`
						},
						createOptions: {
							type: `deceasedSiblingAge`,
							dataType: "string"
						}
					}
				},
				{
					label: `(If Deceased) Cause of death`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0deceasedSiblingCauseOfDeath`,
					props: {
						suggest: {
							typeIncludes: `deceasedSiblingCauseOfDeath`
						},
						createOptions: {
							type: `deceasedSiblingCauseOfDeath`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
